import CustomIcon from "@/components/ui/custom-icon";
import { Dialog } from "radix-ui";
import { FC, useState } from "react";
import S from "./index.module.scss";
import LoginForm from "./components/login";
import RegisterForm from "./components/register";
import { ModalStateType } from "./types";

interface IAuth {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  redirectTo?: string;
}

const AuthModal: FC<IAuth> = ({ open = true, onOpenChange, redirectTo }) => {
  const [state, setState] = useState<ModalStateType>("login");

  const handleClose = (isOpen: boolean) => {
    setState("login");
    onOpenChange(isOpen);
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleClose}>
      <Dialog.Portal>
        <Dialog.Overlay className={S.overlay} />
        <Dialog.Content className={S.content}>
          <Dialog.Close asChild>
            <button type="button" className={S.closeButton} aria-label="Закрыть окно">
              <CustomIcon fileName="icon-close" className={S.closeIcon} />
            </button>
          </Dialog.Close>

          <div className={S.panel}>
            <div className={S.topBar} />
            {state === "login" ? (
              <LoginForm setState={setState} handleClose={handleClose} redirectTo={redirectTo} />
            ) : (
              <RegisterForm key={state} setState={setState} state={state} />
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AuthModal;
